'use client';

import { useState } from 'react';

export default function GatePage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleUnlock = (e: React.FormEvent) => {
    e.preventDefault();
    
    // =========================================================
    // 🔑 CHANGE YOUR PASSWORD HERE! 🔑
    // Replace 'secret2026' with whatever password you want to use.
    // =========================================================
    if (password === 'Liban@Koweit1') {
      // Give them the "VIP Wristband" (lasts 7 days)
      document.cookie = "site_access=granted; path=/; max-age=604800";
      window.location.href = '/homepage'; 
    } else {
      setError('Incorrect access code. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-white">
      
      {/* LEFT SIDE: Visuals (Embassy Image & Flag) */}
      <div className="md:w-1/2 relative hidden md:flex flex-col justify-end bg-slate-900 overflow-hidden">
        
        {/* 📸 BACKGROUND IMAGE: Put your embassy image path here! */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-50 transition-transform duration-1000 hover:scale-105"
          style={{ backgroundImage: "url('/images/embassy-building.jpg')" }} 
        />
        
        {/* Elegant Dark Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-blue-950 via-blue-900/60 to-transparent" />
        
        {/* Text and Flag Overlay */}
        <div className="relative z-10 p-12 lg:p-20 text-white">
          
          {/* Lebanese Flag (Pure CSS perfectly constructed) */}
          <div className="w-20 h-14 mb-8 rounded-sm overflow-hidden shadow-2xl border border-white/20">
            <div className="h-full w-full flex flex-col">
              <div className="h-1/3 bg-[#ED1C24]"></div>
              <div className="h-1/3 bg-white flex items-center justify-center">
                {/* CSS Cedar Tree representation */}
                <span className="text-[#00A651] text-2xl leading-none -mt-1">🌲</span>
              </div>
              <div className="h-1/3 bg-[#ED1C24]"></div>
            </div>
          </div>

          <h1 className="text-4xl lg:text-5xl font-bold mb-3 tracking-tight">Embassy of Lebanon</h1>
          <p className="text-lg lg:text-xl text-blue-100 tracking-[0.2em] uppercase font-medium">State of Kuwait</p>
        </div>
      </div>

      {/* RIGHT SIDE: The Bouncer Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8 lg:p-24 bg-gray-50">
        <div className="max-w-md w-full">
          
          <div className="mb-10 text-center md:text-left">
            <div className="w-14 h-14 bg-blue-100 text-blue-900 rounded-2xl flex items-center justify-center mb-6 mx-auto md:mx-0 shadow-inner">
              {/* Modern Lock Icon */}
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
              </svg>
            </div>
            <h2 className="text-3xl font-extrabold text-gray-900 mb-3 tracking-tight">Secure Portal</h2>
            <p className="text-gray-500 text-base leading-relaxed">
              The embassy website is currently undergoing final reviews. Please enter your authorized access code to proceed.
            </p>
          </div>

          <form onSubmit={handleUnlock} className="space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide">Access Code</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-5 py-4 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all tracking-widest bg-white shadow-sm text-lg"
              />
            </div>
            
            {error && (
              <p className="text-red-500 text-sm font-bold animate-pulse flex items-center gap-2 bg-red-50 p-3 rounded-lg border border-red-100">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                {error}
              </p>
            )}

            <button 
              type="submit" 
              className="w-full bg-blue-900 text-white font-bold py-4 rounded-xl hover:bg-blue-800 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex justify-center items-center gap-3 text-lg"
            >
              Unlock Website
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </form>

          <div className="mt-12 pt-6 border-t border-gray-200 text-center md:text-left">
            <p className="text-sm font-medium text-gray-400">© 2026 Embassy of Lebanon in Kuwait.</p>
          </div>

        </div>
      </div>
    </div>
  );
}